<div style="position: relative; height: 100vh;">
  <div>
    <div
      id="content"
      class="row"
      [class.sidebar-open]="isSidebarOpen"
      [class.sidebar-closed]="!isSidebarOpen"
      style="
        margin: 0;
        height: 100vh;
        overflow: hidden;
        display: flex;
        flex-wrap: nowrap;
        align-items: stretch;
        box-sizing: border-box;
        min-width: 0;
      "
    >
      <!-- LEFT SLIDE -->
      <div
        #chatSlide
        class="chat slide"
        [ngClass]="{
          min: signedFileUrl,
          full: !signedFileUrl,
          'split-mode': showRightSlide,
          'full-width': !showRightSlide
        }"
        [style.width.%]="showRightSlide ? leftPanelWidth : 100"
        style="min-width: 0; display: flex; flex-direction: column; position: relative;"
      >
        <div *ngIf="isDragging" class="drag-overlay"></div>
        <!-- CHAT -->
        <!-- Loading state (shown when loading dataspace) -->
        <div *ngIf="loading" class="d-flex align-items-center justify-content-center h-100">
          <div class="text-center">
            <div class="spinner-border mb-3" role="status" style="width: 3rem; height: 3rem">
              <span class="visually-hidden">Loading...</span>
            </div>
            <h5>Loading dataspace...</h5>
            <p class="text-muted">Please wait while we load your files.</p>
          </div>
        </div>
        
        <!-- Empty state (shown when no files) -->
        <app-empty-state
          *ngIf="!loading && !files.length && !filesCurrentlyUploading && !isGeneratingSchema && !isManualModeUploadInProgress"
          [activeTable]="activeTable"
          [valid_files]="valid_files"
          [valid_MIME_types]="valid_MIME_types"
          [valid_extensions]="valid_extensions"
          [uploadFileLoading]="uploadFileLoading"
          [workflowType]="workflowType"
          [isSidebarOpen]="isSidebarOpen"
          [isGeneratingSchema]="isGeneratingSchema"
          (fileDropped)="
            onItemDrop(
              $event.event,
              $event.isDrop,
              $event.dataspaceCreated,
              $event.workspaceName,
              $event.selectedTemplate
            )
          "
          (workflowSelected)="onWorkflowSelect($event)"
          (templateSelected)="onTemplateSelected($event)"
          style="flex: 1; width: 100%; height: 100%"
        ></app-empty-state>
        
        <!-- Main content area with file preview (shown when files exist) -->
        <ng-container *ngIf="!loading && (files.length > 0 || filesCurrentlyUploading > 0 || isGeneratingSchema || isManualModeUploadInProgress)">
          <!-- File preview container - takes remaining space -->
          <div class="file-preview-wrapper" [style.pointer-events]="isDragging ? 'none' : 'auto'" style="position: relative; flex: 1 1 auto; display: flex; flex-direction: column; min-height: 0; overflow: hidden;">
            <div class="file-preview-out-of-sync" *ngIf="schemaHasChanged && hasStructuredFiles">
              <div class="file-preview-out-of-sync-title">
                <span class="file-preview-out-of-sync-dot"></span>
                <span>OUT OF SYNC</span>
              </div>
              <div class="file-preview-out-of-sync-text">
                Highlights may not match the current schema structure. Apply changes to update.
              </div>
            </div>
            <!-- Bootstrap Left Side Tab Navigation -->
            <nav class="mx-2 d-flex" *ngIf="hasDocumentHtml">
              <div class="custom-tab-container">
                <button
                  class="custom-tab-button"
                  [class.active]="activeView === 'document'"
                  [class.template-tab-blinking]="templateTabBlinking"
                  id="nav-document-view"
                  (click)="setActiveView('document')"
                  type="button"
                  role="tab"
                  aria-controls="nav-document"
                  [attr.aria-selected]="activeView === 'document'"
                >
                  <img src="assets/img/icons/document.svg" alt="Structure" class="button-icon" />
                  Document
                </button>
                <button
                  class="custom-tab-button"
                  [class.active]="activeView === 'content'"
                  [class.template-tab-blinking]="templateTabBlinking"
                  [class.disabled]="selectedFileSegments.length === 0"
                  [disabled]="selectedFileSegments.length === 0"
                  [ngbTooltip]="selectedFileSegments.length === 0 ? 'Content available after extraction' : ''"
                  placement="top"
                  triggers="manual"
                  #tooltip="ngbTooltip"
                  id="nav-content-view"
                  (click)="setActiveView('content')"
                  type="button"
                  role="tab"
                  aria-controls="nav-content"
                  [attr.aria-selected]="activeView === 'content'"
                >
                  <img src="assets/img/icons/markdown.svg" alt="Structure" class="button-icon" />
                  Content
                </button>
              </div>
            </nav>
            <ng-container *ngIf="signedFileUrl && activeView === 'content'">
              <div class="content-container" (click)="resetSegmentView()">
                <ng-container *ngFor="let segment of selectedFileSegments">
                  <div [id]="'segment-' + segment.id" [innerHTML]="segment.html" class="segment-element"></div>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="signedFileUrl && activeView === 'document'">
              <app-file-preview
                [signedUrl]="signedFileUrl"
                [mimeType]="fileMimeType"
                [isNewDataspace]="isNewDataspaceCreated"
                [class.dragging-disabled]="isDragging"
                style="flex: 1;"
              ></app-file-preview>
            </ng-container>
          </div>
          
          <!-- File picker - pushes content up, stays at bottom -->
          <ng-container *ngIf="tableHasFile">
            <app-file-picker
              [files]="files"
              [tableId]="activeTable"
              [selected_file_index]="selected_file_index"
              [filesCurrentlyUploading]="filesCurrentlyUploading"
              [valid_MIME_types]="valid_MIME_types"
              [valid_extensions]="valid_extensions"
              [valid_files]="valid_files"
              [isGeneratingSchema]="isGeneratingSchema"
              (fileSelected)="selectFile($event)"
              (fileDropped)="onSubItemDrop($event.event, $event.isDrop)"
              (fileInvalid)="onInvalidFiles($event)"
            ></app-file-picker>
          </ng-container>
        </ng-container>
        
        <!-- Show placeholder content when schema is generating but no files/content loaded yet -->
        <ng-container *ngIf="!loading && isGeneratingSchema && !tableHasFile && !signedFileUrl && files.length === 0">
          <div class="d-flex align-items-center justify-content-center h-100">
            <div class="text-center">
              <div class="spinner-border mb-3" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <h6>Processing your file...</h6>
              <p class="text-muted">Please wait while we analyze your document.</p>
            </div>
          </div>
        </ng-container>
        
        <!-- Show placeholder content when manual mode upload is in progress but no files/content loaded yet -->
        <ng-container *ngIf="!loading && isManualModeUploadInProgress && !tableHasFile && !signedFileUrl && files.length === 0">
          <div class="d-flex align-items-center justify-content-center h-100">
            <div class="text-center">
              <div class="spinner-border mb-3" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <h6>Uploading your file...</h6>
              <p class="text-muted">Please wait while we upload your document.</p>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- DIVIDER LINE -->
      <div
        #dividerLine
        class="divider-line"
        [class.dragging]="isDragging"
        *ngIf="showRightSlide"
        (mousedown)="onSplitterMouseDown($event)"
      ></div>

      <!-- RIGHT SLIDE -->
      <div
        #tableSlide
        class="data-panel"
        [ngClass]="{ show: showRightSlide }"
        [style.width.%]="rightPanelWidth"
        *ngIf="showRightSlide"
      >
        <!-- Bootstrap Tab Navigation -->
        <nav class="d-flex navigation-panel">
          <div class="custom-tab-container ms-2">
            <button
              class="custom-tab-button"
              [class.active]="activeTab === 'schema'"
              [class.template-tab-blinking]="templateTabBlinking"
              [disabled]="isGeneratingSchema || loading"
              id="nav-schema-tab"
              (click)="setActiveTab('schema')"
              type="button"
              role="tab"
              aria-controls="nav-schema"
              [attr.aria-selected]="activeTab === 'schema'"
            >
              <img src="assets/img/icons/settings.svg" alt="Data Fields" class="button-icon" />
              Data Fields
            </button>
            <button
              class="custom-tab-button"
              [class.active]="activeTab === 'document-data'"
              [disabled]="isGeneratingSchema || loading || !files.length"
              id="nav-document-data-tab"
              (click)="setActiveTab('document-data')"
              type="button"
              role="tab"
              aria-controls="nav-document-data"
              [attr.aria-selected]="activeTab === 'document-data'"
            >
              <img src="assets/img/icons/spreadsheet_icon.svg" alt="This Document" class="button-icon" />
              This Document
            </button>
            <button
              class="custom-tab-button"
              [class.active]="activeTab === 'spreadsheet'"
              [disabled]="isGeneratingSchema || loading"
              id="nav-spreadsheet-tab"
              (click)="setActiveTab('spreadsheet')"
              type="button"
              role="tab"
              aria-controls="nav-spreadsheet"
              [attr.aria-selected]="activeTab === 'spreadsheet'"
            >
              <img src="assets/img/icons/table-custom.svg" alt="Dataset" class="button-icon" />
              Dataset
            </button>
            <!-- Integrations tab temporarily disabled -->
            <button
              *ngIf="false"
              class="custom-tab-button"
              [class.active]="activeTab === 'integrations'"
              [disabled]="isGeneratingSchema || loading"
              id="nav-integrations-tab"
              (click)="setActiveTab('integrations')"
              type="button"
              role="tab"
              aria-controls="nav-integrations"
              [attr.aria-selected]="activeTab === 'integrations'"
            >
              <img src="assets/img/icons/integrations_icon.svg" alt="Integrations" class="button-icon" />
              Integrations
            </button>
          </div>
          <div class="buttons-group gap-3 pe-3">
            <button *ngIf="getUserRole() === 'demo'"
              type="button"
              class="id-icon-btn"
              [disabled]="isGeneratingSchema || loading || !isCorrelationIdAvailable()"
              (click)="copyToClipboardClick()"
              (mouseenter)="setCopyToClipboardIcon()"
              (mouseleave)="setCopyToClipboardIcon()"
              title="Correlation Id"
              ngbTooltip="Copied!"
              #tooltip="ngbTooltip"
              placement="left"
              triggers="manual">
              <div class="id-icon">
                <img src="assets/img/icons/correlation_id_icon.svg" alt="Correlation Id" class="button-icon" />
              </div>
            </button>
            <!-- Schema Settings Icon Button -->
            <button *ngIf="activeTab === 'schema'" type="button"
              class="info-icon-btn"
              (click)="openSchemaSettings()"
              triggers="hover">
              <i class="bi bi-wrench-adjustable-circle"></i>
            </button>
            <!-- JSON View Icon Button - Right Aligned -->
            <button
              class="info-icon-btn"
              [class.active]="showJsonView"
              [disabled]="isGeneratingSchema || loading"
              [class.clicked]="showJsonView"
              (click)="toggleJsonView()"
              type="button"
              title="JSON View"
            >
              <i class="bi bi-code-square"></i>
            </button>
          </div>
        </nav>

        <!-- Tab Content -->
        <div class="tab-content" id="nav-tabContent">
          <!-- Loading dataspace state -->
          <div
            class="tab-pane fade show active"
            *ngIf="loading"
            style="height: 100%; display: flex; align-items: center; justify-content: center;"
          >
            <div class="text-center">
              <div class="spinner-border mb-3" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <h6>Loading your data...</h6>
              <p class="text-muted">This may take a moment if you have many files.</p>
            </div>
          </div>
          
          <div
            class="tab-pane fade"
            [class.show]="activeTab === 'generating-schema' && !loading"
            [class.active]="activeTab === 'generating-schema' && !loading"
            id="nav-generating-schema"
            role="tabpanel"
            aria-labelledby="nav-generating-schema-tab"
          >
            <div class="card-body schema-generating-infobox">
              <div class="spinner-border" role="status"></div>
              <div class="d-flex align-items-center gap-3">
                <div class="flex-grow-1">
                  <div>
                    <h6 class="mb-2 fw-bold">Just a moment..</h6>
                    <p class="text-muted mb-1">
                      Talonic is analyzing your document and crafting a template
                      recommendation for you.
                    </p>
                    <small class="text-muted"
                      >Once finished, you'll be able to start structuring your
                      data.</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="tab-pane fade"
            [class.show]="activeTab === 'spreadsheet' && !loading"
            [class.active]="activeTab === 'spreadsheet' && !loading"
            id="nav-spreadsheet"
            role="tabpanel"
            aria-labelledby="nav-spreadsheet-tab"
          >
            <app-json-view
              *ngIf="showJsonView"
              [jsonSchema]="getDatasetJsonSchemaString()"
              [tableId]="activeTable"
              [readOnly]="true"
              [viewMode]="'data'"
            ></app-json-view>
            <app-ag-grid-view
              *ngIf="!showJsonView"
              (cellClickedEvent)="onCellClicked($event)"
              [data]="{
                tableId: activeTable,
                tableName: activeTableName,
                sheets: sheets,
                sheet: activeSheet
              }"
              [showLoadingSpinners]="isActiveTableStructuring"
              [schema]="jsonSchema"
              [showQaInfo]="true"
              [isDatasetView]="true"
              [qaActive]="activeTab === 'spreadsheet'"
              [qaDisabled]="false"
            >
            </app-ag-grid-view>
          </div>

          <!-- Document Data Tab - Shows data filtered by selected file -->
          <div
            class="tab-pane fade"
            [class.show]="activeTab === 'document-data' && !loading"
            [class.active]="activeTab === 'document-data' && !loading"
            id="nav-document-data"
            role="tabpanel"
            aria-labelledby="nav-document-data-tab"
          >
            <!-- Loading state -->
            <div *ngIf="documentDataLoading" class="d-flex align-items-center justify-content-center h-100" style="min-height: 300px;">
              <div class="text-center">
                <div class="spinner-border mb-3" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <h6>Loading document data...</h6>
                <p class="text-muted">Fetching data for the selected file.</p>
              </div>
            </div>

            <!-- File info header -->
            <div *ngIf="!documentDataLoading && documentDataFileInfo" class="document-data-header py-2 px-3 border-bottom bg-light">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center gap-2">
                  <img src="assets/img/icons/spreadsheet_icon.svg" alt="File" style="width: 16px; height: 16px;" />
                  <span class="fw-semibold">{{ documentDataFileInfo.fileName }}</span>
                  <span class="text-muted small">•</span>
                  <span class="text-muted small">{{ getDocumentDataRowCount() }} rows in the dataset are from this document</span>
                </div>
                <!-- Info Icon Copy To Clipboard -->
                <button type="button"
                class="info-icon-btn"
                (click)="copyToClipboardDatasetQualityInfoClick()"
                [ngbTooltip]="infoTooltip"
                triggers="hover">
                <i class="bi bi-info-circle"></i>
              </button>
              <ng-template #infoTooltip>
                <div class="tooltip-inner d-flex flex-column align-items-start text-start">
                  <p class="mb-1"><strong>Job ID: </strong>{{documentDataFileInfo.jobId}}</p>
                  <p class="mb-1"><strong>Score: </strong>{{documentDataFileInfo.score}}</p>
                  <p class="mb-1"><strong>Quality: </strong>{{documentDataFileInfo.quality}}</p>
                  <p class="mb-1"><strong>Summary: </strong>{{documentDataFileInfo.summary?.total_fields}} fields, {{documentDataFileInfo.summary?.fields_with_value}} with value, {{documentDataFileInfo.summary?.fields_empty}} empty</p>
                </div>
              </ng-template>
                <!-- Hide QA Info Button for now till the BE is ready-->
                <!-- <app-document-qa-info
                  [tableId]="activeTable"
                  [documentDataFileInfo]="documentDataFileInfo"
                  [fileId]="documentDataFileInfo.id"
                  [jobId]="documentDataFileInfo.jobId"
                  [active]="activeTab === 'document-data'"
                  [disabled]="documentDataLoading"
                ></app-document-qa-info> -->
              </div>
            </div>

            <!-- No file selected state -->
            <div *ngIf="!documentDataLoading && !files.length" class="d-flex align-items-center justify-content-center h-100" style="min-height: 300px;">
              <div class="text-center">
                <img src="assets/img/icons/spreadsheet_icon.svg" alt="No file" style="width: 48px; height: 48px; opacity: 0.5;" />
                <h6 class="mt-3">No files uploaded</h6>
                <p class="text-muted">Upload a file to see its extracted data here.</p>
              </div>
            </div>

            <!-- No data state -->
            <div *ngIf="!documentDataLoading && files.length && !documentDataSheets.length" class="d-flex align-items-center justify-content-center h-100" style="min-height: 300px;">
              <div class="text-center">
                <img src="assets/img/icons/spreadsheet_icon.svg" alt="No data" style="width: 48px; height: 48px; opacity: 0.5;" />
                <h6 class="mt-3">No data for this document</h6>
                <p class="text-muted">This file hasn't been structured yet or contains no extractable data.</p>
              </div>
            </div>

            <!-- Grid view for document data -->
            <app-json-view
              *ngIf="!documentDataLoading && documentDataSheets.length && showJsonView"
              [jsonSchema]="getDocumentJsonSchemaString()"
              [tableId]="activeTable"
              [readOnly]="true"
              [viewMode]="'data'"
            ></app-json-view>
            <app-ag-grid-view
              *ngIf="!documentDataLoading && documentDataSheets.length && !showJsonView"
              (cellClickedEvent)="onCellClicked($event)"
              [data]="{
                tableId: activeTable,
                tableName: activeTableName,
                sheets: documentDataSheets,
                sheet: documentDataSheet,
                fileName: documentDataFileInfo?.fileName
              }"
              [showLoadingSpinners]="false"
              [schema]="jsonSchema"
            >
            </app-ag-grid-view>
          </div>

          <div
            class="tab-pane fade"
            [class.show]="activeTab === 'schema' && !loading"
            [class.active]="activeTab === 'schema' && !loading"
            id="nav-schema"
            role="tabpanel"
            aria-labelledby="nav-schema-tab"
          >
            <app-json-view
              *ngIf="showJsonView"
              [jsonSchema]="jsonSchema"
              [tableId]="activeTable"
              [schemaSettings]="schemaSettings"
              [schemaConfig]="schemaConfig"
              [viewMode]="'schema'"
              [readOnly]="false"
              (jsonSchemaChanged)="jsonSchema = $event"
              (formValid)="formIsValid = $event"
              (schemaSettingsChanged)="schemaSettings = $event"
            ></app-json-view>
            <div class="schema-builder-container position-relative p-0" *ngIf="!showJsonView">
              <!-- Schema Builder Popup -->
              <div class="schema-builder-popup" *ngIf="showSchemaBuilderPopup">
                <div class="popup-content">
                  <div class="popup-text-with-arrow">
                    <p>
                      This is the template we recommend to structure your
                      documents in. Every card represents one column in your
                      dataset. Please review the template and click "Structure"
                      on the bottom right to start processing your documents
                    </p>
                    <i class="bi bi-arrow-right-square-fill popup-arrow"></i>
                  </div>
                  <div class="do-not-show-again mt-3">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="doNotShowAgain"
                        (change)="onDoNotShowAgainChange($event)"
                      />
                      <label class="form-check-label" for="doNotShowAgain">
                        Do not show this message again
                      </label>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    (click)="hideSchemaBuilderTooltip()"
                  ></button>
                </div>
              </div>
              <app-schema-builder
                [jsonSchema]="jsonSchema"
                [tableId]="activeTable"
                [shellLoading]="loading"
                [schema_id]="schema_id"
                [schema_name]="schema_name"
                [files]="files"
                [schemaSettings]="schemaSettings"
                [schemaConfig]="schemaConfig"
                [structureSuccessTrigger]="structureSuccessTrigger"
                [hasStructuredFiles]="hasStructuredFiles"
                (jsonSchemaChanged)="jsonSchema = $event"
                (formValid)="formIsValid = $event"
                (schemaChanged)="schemaHasChanged = $event"
                (applyAndResolve)="structureData()"
              >
              </app-schema-builder>
            </div>
          </div>

          <!-- Integrations panel temporarily disabled -->
          <div
            *ngIf="false"
            class="tab-pane fade"
            [class.show]="activeTab === 'integrations' && !loading"
            [class.active]="activeTab === 'integrations' && !loading"
            id="nav-integrations"
            role="tabpanel"
            aria-labelledby="nav-integrations-tab"
          >
            <app-integrations></app-integrations>
          </div>

          <!-- Job Management Panel (shown during structuring) -->
          <div
            class="tab-pane fade"
            [class.show]="activeTab === 'job-management' && !loading"
            [class.active]="activeTab === 'job-management' && !loading"
            id="nav-job-management"
            role="tabpanel"
            aria-labelledby="nav-job-management-tab"
            style="height: 100%;"
          >
            <app-job-management
              *ngIf="files[selected_file_index]"
              [tableId]="activeTable"
              [fileId]="files[selected_file_index].id || ''"
              [fileResourceKey]="files[selected_file_index].resourceKey || ''"
              [fileProcessId]="files[selected_file_index].processId || ''"
              [tableName]="activeTableName"
              [fileName]="files[selected_file_index].fileName || ''"
              [isStructuring]="isActiveTableStructuring"
              [fileStatus]="files[selected_file_index].status"
              [processingProgress]="processingProgress"
              [estimatedTotalSeconds]="estimatedProcessingTimeSeconds || 120"
              (cancel)="cancelStructuring()"
              (runInBackground)="onRunInBackground($event)"
              (completed)="onJobManagementCompleted()"
            ></app-job-management>
          </div>
        </div>

        <ng-container *ngIf="activeTab !== 'job-management'">
          <div
            id="structure-button"
            class="d-flex gap-2"
          >
            <!-- Structure Button -->
            <button
              class="btn btn-success"
              (click)="structureData()"
              [disabled]="isStructureButtonDisabled"
              *ngIf="!isActiveTableStructuring && !cancelling"
              [ngbTooltip]="getStructureButtonTooltip()"
              placement="top-start"
              tooltipClass="structure-tooltip"
              container="body"
            >
              <img src="assets/img/icons/ai-sparkles.svg" alt="AI" class="button-icon" />
              {{ structureButtonText }}
            </button>
            <button class="btn btn-success" disabled *ngIf="cancelling">
              <span
                class="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
              Cancelling...
            </button>

            <!-- View Progress Button (when running in background) -->
            <button
              class="btn btn-outline-primary btn-view-progress"
              (click)="showJobManagement()"
              *ngIf="isActiveTableStructuring && !cancelling"
            >
              View Progress
            </button>

            <!-- Cancel Button -->
            <button
              class="btn btn-outline-danger"
              (click)="cancelStructuring()"
              *ngIf="canCancelStructuring"
            >
              Cancel
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- PDF Page Limit Modal -->
<ng-template #pdfPageLimitModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        id="btn-close"
        (click)="modal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>PDF Page Limit Exceeded</h4>
          <p class="mt-4">
            Your PDF file exceeds the 10-page limit. To process larger files,
            please upgrade your plan.
          </p>
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button
          class="btn btn-link link-success fw-medium text-decoration-none"
          data-bs-dismiss="modal"
          (click)="modal.close('Close click')"
        >
          <i class="ri-close-line me-1 align-middle"></i> Close
        </button>
        <a
          href="https://www.talonic.com/get-started"
          target="_blank"
          class="btn btn-primary"
          data-umami-event="Talk to Sales"
        >
          Talk to sales
        </a>
      </div>
    </div>
  </div>
</ng-template>

<!-- Non-PDF File Modal -->
<ng-template #wrongFileTypeModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        id="btn-close"
        (click)="modal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>File Type Not Available</h4>
          <p class="mt-4">
            Currently, we only support PDF files and images in our free tier. To
            structure other file types like spreadsheets or documents, please
            contact our sales team to learn about our enterprise solutions.
          </p>
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button
          class="btn btn-link link-success fw-medium text-decoration-none"
          data-bs-dismiss="modal"
          (click)="modal.close('Close click')"
        >
          <i class="ri-close-line me-1 align-middle"></i> Close
        </button>
        <a
          href="https://www.talonic.com/get-started"
          target="_blank"
          class="btn btn-primary"
        >
          Talk to sales
        </a>
      </div>
    </div>
  </div>
</ng-template>

<!-- Existing File Modal -->
<ng-template #existingFileModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.dismiss('Cross click')"></button>
    </div>
  </div>
  <div class="modal-body text-start">
    <div class="mt-2 text-center">
      <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
        <h4>File(s) already uploaded</h4>
        <div class="mt-4">
          The file(s) you are trying to upload already exist in the table. Please select whether to append or skip them.
          <ul>
            <li *ngFor="let fileName of _existingFiles">{{ fileName }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="modal.close('append')">Append</button>
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="modal.close('skip')">Skip</button>
  </div>
</ng-template>

<!-- Interrupted Upload Modal -->
<ng-template #interruptedUploadModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Upload interrupted</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.dismiss('Close')"></button>
    </div>
    <div class="modal-body">
      <p class="mb-0">The upload was interrupted. Drop the files again to complete the upload.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="modal.close('OK')">OK</button>
    </div>
  </div>
</ng-template>
